import { encodeFiPaymentId } from '@debbie/common/dist/economy/helpers/utils.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { CopyToClipboard } from '../../index.js';
import { PaymentId } from './index.js';
const FI = (props) => {
    const { paymentOption, case: singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const fikID = encodeFiPaymentId(parseInt(`${singleCase.id}0`));
    return (React.createElement("div", null,
        React.createElement("h2", null, lang.debtorWebHome.payWithFI),
        React.createElement("p", null, lang.debtorWebHome.paySafeWithFI),
        React.createElement(PaymentId, null,
            "+71",
            '>',
            " ",
            React.createElement(CopyToClipboard, { text: fikID }, fikID),
            " +",
            React.createElement(CopyToClipboard, { text: `${
                // @ts-ignore
                (paymentOption.details && paymentOption.details.creditorNumber) ||
                    'XXXXXXX'}` }, 
            // @ts-ignore
            (paymentOption.details && paymentOption.details.creditorNumber) ||
                'XXXXXXX'),
            ' ',
            '<')));
};
export default FI;
//# sourceMappingURL=FI.js.map